import axios from "axios";
import { getFromStorage } from "./";

axios.defaults.headers.post["Content-Type"] = "application/json";

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
  isAuth = true,
}) {
  const reqObj = {
    method,
    url: import.meta.env.VITE_API_BASE_URL + path,
    headers,
  };

  reqObj.params = queryParams;

  if (method !== "GET") {
    reqObj.data = postData;
    if (postData instanceof FormData) {
      reqObj.headers["Content-Type"] = "multipart/form-data";
    }
  }

  if (isAuth) {
    reqObj.headers.Authorization = `Bearer ${getFromStorage("accessToken")}`;
  }

  // console.log("<===REQUEST-OBJECT===>", reqObj);

  try {
    const results = await axios(reqObj);
    // console.log("<===Api-Success-Result===>", results);

    return results.data;
  } catch (error) {
    console.log("<===Api-Error===>", error);

    if (error.response?.status === 401) {
      sessionStorage.clear();
      window.location.reload();
    }

    throw new Error(
      error.response?.data?.message || error.message || "Something went wrong"
    );
  }
}
